var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { baseColors } from '../../../Themes/colors';
var GREEN = baseColors.successPreset[40];
var GREEN_BORDER = baseColors.successPreset[40];
var GREEN_LINE = baseColors.successPreset[40];
var GREEN_HALO = '#E3F4EB';
var TEXT_DARK = '#374151';
var ApplicationStatusFlow = function (_a) {
    var steps = _a.steps, _b = _a.compact, compact = _b === void 0 ? false : _b;
    var height = compact ? 26 : 30;
    var iconSize = compact ? 14 : 16;
    var getConnectorStyle = function (currentStep, nextStep) {
        if (currentStep.status === 'completed' && (nextStep.status === 'completed' || nextStep.status === 'active')) {
            return { backgroundColor: GREEN_LINE, borderTop: 'none', borderRadius: 2 };
        }
        return { backgroundColor: 'transparent', borderTop: "2px dashed ".concat(baseColors.greyPreset[40]) };
    };
    var renderPill = function (step, index) {
        var isActive = step.status === 'active';
        var isCompleted = step.status === 'completed';
        return (React.createElement(Stack, { direction: "row", alignItems: "center", sx: {
                height: height,
                gap: '7px',
                pl: "".concat((height - iconSize) / 2 + 2, "px"),
                pr: '12px',
                borderRadius: 999,
                whiteSpace: 'nowrap',
                flexShrink: 0,
                backgroundColor: isActive ? GREEN : baseColors.fullWhite,
                border: "1px solid ".concat(isActive ? GREEN : isCompleted ? GREEN_BORDER : baseColors.greyPreset[40]),
                boxShadow: isActive ? "0 0 0 4px ".concat(GREEN_HALO) : 'none',
            } },
            isCompleted && (React.createElement(Box, { sx: {
                    width: iconSize,
                    height: iconSize,
                    borderRadius: '50%',
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: GREEN,
                } },
                React.createElement(CheckIcon, { sx: { fontSize: iconSize - 5, color: baseColors.fullWhite } }))),
            isActive && (React.createElement(Box, { sx: {
                    width: iconSize,
                    height: iconSize,
                    borderRadius: '50%',
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'rgba(255, 255, 255, 0.3)',
                } },
                React.createElement(Typography, { sx: { fontSize: compact ? 10 : 11, fontWeight: 600, lineHeight: 1, color: baseColors.fullWhite } }, index + 1))),
            React.createElement(Typography, { sx: {
                    fontSize: compact ? 12 : 13,
                    fontWeight: isActive ? 700 : 500,
                    lineHeight: 1,
                    ml: !isActive && !isCompleted ? '8px' : 0,
                    color: isActive ? baseColors.fullWhite : isCompleted ? TEXT_DARK : baseColors.bluePreset[40],
                } }, step.label)));
    };
    return (React.createElement(Stack, { direction: "row", alignItems: "center", sx: { flexWrap: 'nowrap', py: '5px' } }, steps.map(function (step, index) { return (React.createElement(Box, { key: index, sx: { display: 'flex', alignItems: 'center' } },
        renderPill(step, index),
        index < steps.length - 1 && (React.createElement(Box, { sx: __assign({ width: compact ? 16 : 22, height: 2, flexShrink: 0, mx: '6px' }, getConnectorStyle(step, steps[index + 1])) })))); })));
};
export default ApplicationStatusFlow;
